import {
  USER_SELECT_FETCH_STARTED,
  USER_SELECT_FETCH_SUCCEEDED,
  USER_SELECT_FETCH_FAILED,
  USER_SELECT_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();
export const fetchSelectUsers = filter => async dispatch => {
  try {
    abortController.abort();
    dispatch({
      type: USER_SELECT_FETCH_STARTED
    });

    const params = new URLSearchParams({
      limit: 100
    });
    if (filter) {
      params.set('filterBy', ['fullName', 'email']);
      params.set('filter', filter);
      if (filter.length === 1) return;
    }
    const url = webPortalApi.buildApiUrl(`users?${params.toString()}`);
    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const users = await res.json() ?? [];

    dispatch({
      type: USER_SELECT_FETCH_SUCCEEDED,
      payload: users
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: USER_SELECT_FETCH_FAILED,
      error: e
    });
  }
};

export const clearSelectUsers = () => dispatch => {
  abortController.abort();
  dispatch({
    type: USER_SELECT_CLEAR
  });
};
